<div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-[30%] text-center" *ngIf="isLoading" >
    <div class="ml-[18%] text-white rounded-3xl  max-w-md w-full p-2 py-3 ">
        <div class="join">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
</div>